/* initiate AOS animations */
//AOS.init();

jQuery('a[href="#top"]').click(function(){
    jQuery('html, body').animate({scrollTop:0}, 'smooth');
});



$('.grid').masonry({
  // options
  itemSelector: '.grid-item',
  columnWidth: 200
});
// layout Masonry after each image loads
$grid.imagesLoaded().progress( function() {
  $grid.masonry('layout');
});

$(document).ready(function () {
    var $horizontal = $('.mover');
    var startPosition = $horizontal.position().left;
    var speed = 14;
    $(window).scroll(function () {
        var st = $(this).scrollTop();
        var newPos = (st * (speed/100)) + startPosition;
        $horizontal.css({
            'left': newPos
        });
    });
});